/** @jsx jsx */
import { jsx } from '@emotion/core';
import CybsButton from '@cybs-ui/components/lib/button';
// Styles
import css from './breadcrumb.styles';

const BreadCrumb = (
  { href, pageTitle, onClick, ...rest },
  idx,
  breadCrumbs
) => [
  <li css={css} key={`${href}-${pageTitle + idx}`}>
    {href ? (
      <CybsButton
        href={href}
        i18n={{ label: pageTitle }}
        onClick={onClick}
        tag="a"
        variant="link"
        colorScheme="secondary"
        {...rest}
      />
    ) : (
      <span>{pageTitle}</span>
    )}
    <span aria-hidden="true">{idx === breadCrumbs.length - 1 ? '' : '/'}</span>
  </li>
];

export default BreadCrumb;
